import { useEffect } from 'react';
import LoadingButton from '../LoadingButton';
import { usePaymentSession } from './hooks/usePaymentSession';
import { FaCcVisa } from 'react-icons/fa';

function CardForm({
  amount,
  sessionId,
  isProcessing,
  onSubmit,
  onCancel
}) {
  const handleSessionUpdate = (update) => {
    if (update.type === 'error') {
      console.error('Payment form error:', update.message);
      return;
    }

    if (update.type === 'update' && update.response?.status === 'ok') {
      onSubmit(new Event('submit'));
    }
  };

  const { updateSession } = usePaymentSession({
    sessionId,
    onUpdate: handleSessionUpdate
  });

  const formatCurrency = (value) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD'
    }).format(value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    e.stopPropagation();
    updateSession();
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      {/* <div className="mb-6 p-3 bg-primary-50 dark:bg-primary-900/20 rounded-lg">
        <div className="flex justify-between items-center">
          <span className="text-sm text-gray-600 dark:text-gray-300">Amount to Pay:</span>
          <span className="font-medium text-gray-900 dark:text-white">
            {formatCurrency(amount)}
          </span>
        </div>
      </div> */}

      <div>
        <label htmlFor="cardholder-name" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
          Cardholder Name
        </label>
        <input
          type="text"
          id="cardholder-name"
          className="block w-full rounded-md border border-gray-300 dark:border-gray-600 px-3 py-2 shadow-sm focus:border-primary focus:outline-none focus:ring-primary sm:text-sm dark:bg-gray-700 dark:text-white"
          readOnly
        />
      </div>

      <div>
        <div className="flex justify-between items-center mb-1">
          <label htmlFor="card-number" className="text-sm font-medium text-gray-700 dark:text-gray-300">
            Card Number
          </label>
          <div className="flex items-center gap-1">
            <FaCcVisa className="h-6 w-6 text-[#1A1F71]" />
            <img src="/mc_icon.svg" alt="Mastercard" className="h-6 w-6" />
          </div>
        </div>
        <input
          type="text"
          id="card-number"
          className="block w-full rounded-md border border-gray-300 dark:border-gray-600 px-3 py-2 shadow-sm focus:border-primary focus:outline-none focus:ring-primary sm:text-sm dark:bg-gray-700 dark:text-white"
          readOnly
        />
      </div>

      <div className="grid grid-cols-3 gap-4">
        <div>
          <label htmlFor="expiry-month" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
            Month
          </label>
          <input
            type="text"
            id="expiry-month"
            className="block w-full rounded-md border border-gray-300 dark:border-gray-600 px-3 py-2 shadow-sm focus:border-primary focus:outline-none focus:ring-primary sm:text-sm dark:bg-gray-700 dark:text-white"
            readOnly
          />
        </div>
        <div>
          <label htmlFor="expiry-year" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
            Year
          </label>
          <input
            type="text"
            id="expiry-year"
            className="block w-full rounded-md border border-gray-300 dark:border-gray-600 px-3 py-2 shadow-sm focus:border-primary focus:outline-none focus:ring-primary sm:text-sm dark:bg-gray-700 dark:text-white"
            readOnly
          />
        </div>
        <div>
          <label htmlFor="security-code" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
            CVV
          </label>
          <input
            type="text"
            id="security-code"
            className="block w-full rounded-md border border-gray-300 dark:border-gray-600 px-3 py-2 shadow-sm focus:border-primary focus:outline-none focus:ring-primary sm:text-sm dark:bg-gray-700 dark:text-white"
            readOnly
          />
        </div>
      </div>

      <div className="flex justify-end gap-3 mt-6">
        <button
          type="button"
          onClick={onCancel}
          className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 dark:bg-gray-700 dark:text-gray-300 dark:border-gray-600 dark:hover:bg-gray-600"
          disabled={isProcessing}
        >
          Back
        </button>
        <LoadingButton
          type="submit"
          isProcessing={isProcessing}
          loadingText="Processing..."
        >
          Complete Payment
        </LoadingButton>
      </div>
    </form>
  );
}

export default CardForm;